import type { TenancyTO } from '../../../lib';

export interface SearchPageContent {
  title: string;
  description: string[];
  searchPlaceholder: string;
}

const DEFAULT_SEARCH_PLACEHOLDER =
  'Use Quick Search to filter your patient dashboard';

const DEFAULT_SEARCH_PAGE_TITLE = 'Welcome';

export const DEFAULT_SEARCH_PAGE_CONTENT: SearchPageContent = {
  title: DEFAULT_SEARCH_PAGE_TITLE,
  description: [
    'To get started, please use the Quick Search below to filter your patient dashboard.',
    'Use a combination of keywords and the suggested quick filter options to guide your filter criteria.',
  ],
  searchPlaceholder: DEFAULT_SEARCH_PLACEHOLDER,
};

export const getSearchPageTitle = (selectedTenancy?: TenancyTO | null) => {
  return (
    selectedTenancy?.features?.searchScreen?.title || DEFAULT_SEARCH_PAGE_TITLE
  );
};

export const getSearchPageContent = (
  selectedTenancy?: TenancyTO | null,
): SearchPageContent => {
  return {
    ...DEFAULT_SEARCH_PAGE_CONTENT,
    title: getSearchPageTitle(selectedTenancy),
  };
};
